/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){


	function initEventListeners(){

		pipEvents.instantRebates.instantRebatesLinkClicked.on('.instantRebatesLinkClicked', function(evtType, data){
			pushAnalyticsEvent(data.eventName);
		});

		pipEvents.priceDetails.priceDetailsLinkClicked.on('.priceDetailsLinkClicked', function(evtType, data){
			pushAnalyticsEvent(data.eventName);
		});

		pipEvents.shippingOptions.shippingOptionsLinkClicked.on(function(evtType, data){
			pushAnalyticsEvent(data.eventName);
		});

	}

	function pushAnalyticsEvent(eventName){

		var obj ={
			category:{
				primaryCategory: 'tooltip'
			},
			eventInfo: {
				eventName: eventName || ''
			}
		};

		if (pip.debugMode) console.log('DDO Tooltip Event', obj);

		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);

	}

	return {
		init: function(){
			initEventListeners();
		}
	}


});

}.call(window));